import { useEffect, useRef, useState } from "react";

export const CustomCursor = () => {
  const dot = useRef(null);
  const ring = useRef(null);
  const [label, setLabel] = useState("");
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    document.body.classList.add("cg-cursor-none");
    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const soft = { x: pos.x, y: pos.y };
    let raf;

    const onMove = (e) => {
      pos.x = e.clientX; pos.y = e.clientY;
      const t = e.target.closest("[data-cursor],a,button,[role='button']");
      setLabel(t ? (t.getAttribute("data-cursor") || (t.tagName === "A" ? "VIEW" : "")) : "");
    };
    const loop = () => {
      soft.x += (pos.x - soft.x) * 0.16;
      soft.y += (pos.y - soft.y) * 0.16;
      if (dot.current) dot.current.style.transform = `translate3d(${pos.x}px,${pos.y}px,0) translate(-50%,-50%)`;
      if (ring.current) ring.current.style.transform = `translate3d(${soft.x}px,${soft.y}px,0) translate(-50%,-50%)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", onMove);
    raf = requestAnimationFrame(loop);
    return () => { window.removeEventListener("mousemove", onMove); cancelAnimationFrame(raf); document.body.classList.remove("cg-cursor-none"); };
  }, []);

  if (!enabled) return null;
  return (
    <div aria-hidden="true" data-testid="custom-cursor">
      <div ref={dot} className="cg-cursor-dot" />
      <div ref={ring} className={`cg-cursor-ring ${label ? "is-active" : ""}`}>
        <span>{label}</span>
      </div>
    </div>
  );
};
